import VueRouter from "vue-router";

import $store from "@/store";

import Pairing from "./pairing";
import Provision from "./Provision";
import Testing from "./Testing";
import Report from "./Report";

const installRouter = new VueRouter({
	// Maintain history in-memory. This is typically used as part of SSR, but
	// here we're using it to coordinate the installation flow without touching
	// the actual URL.
	mode: "abstract",
	routes: [
		{
			// Default route. Start at device pairing screen.
			path: "/",
			name: "Pairing",
			component: Pairing,

			meta: {
				back: { path: "/install", useBaseRouter: true },
				next: () =>
					// Skip provisioning if not required
					$store.getters["install/requiresProvisioning"]
						? { name: "Provision" }
						: { name: "Testing" },
			},
		},
		{
			path: "/provision",
			name: "Provision",
			component: Provision,

			meta: {
				back: { name: "Pairing" },
				next: { name: "Testing" },
			},
		},
		{
			path: "/testing",
			name: "Testing",
			component: Testing,

			meta: {
				back: { name: "Pairing" },
				next: { name: "Report" },
			},
		},
		{
			path: "/report",
			name: "Report",
			component: Report,
		},
	],
});

export default installRouter;
